<template>

  <div class="mb-4">
    <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
      {{ title }}
    </h2>
  </div>

</template>

<script>
export default {
  props: ['title']
};
</script>
